class LocalStorageService {
  static getItem(key) {
    try {
      const item = window.localStorage.getItem(key);
      return item;
    } catch (error) {
      console.log(error);
    }
  }

  static setItem(key, value) {
    try {
      window.localStorage.setItem(
        key,
        typeof value === "object" ? JSON.stringify(value) : value
      );
    } catch (error) {
      console.log(error);
    }
  }

  static removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  }
}

export default LocalStorageService;
